import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { uploadFile } from '../../slices/thunks';

const useUploadFiles = () => {
    const dispatch = useDispatch();
    const [folderId, setFolderId] = useState();
    const [filesUploaded, setFilesUploaded] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);

    const uploadFiles = async (path, meta, files) => {
        setUploading(true)
        let dataFolder = [];
        let dataUploadedFiles = [];

        for (const item of files) {
            let formData = new FormData();
            formData.append('file', item.file);

            try {
                const responseUploadFile = await dispatch(
                    uploadFile({
                        file_path: path,
                        file_type_id: item?.file_type_id,
                        meta: meta,
                        formData: formData
                    })
                ).unwrap();

                setFolderId(responseUploadFile.folder_id);
                dataFolder = [
                    ...dataFolder,
                    ...[responseUploadFile.folder_id]
                ]
                dataUploadedFiles = [
                    ...dataUploadedFiles,
                    ...[responseUploadFile._id]
                ];
                setFilesUploaded(dataUploadedFiles);
                setSuccess(true);
            } catch (err) { 
                console.error('Error al subir archivo:', err);
                setError(true);
            }
        }
        setUploading(false);
        
        return new Promise((resolve, reject) => {
            try {
                // Simula algún caso en el que pueda fallar
                if (!dataFolder || !dataUploadedFiles) {
                    throw new Error("dataFolder o dataUploadedFiles no están definidos.");
                }
                resolve({
                    folder: dataFolder,
                    files: dataUploadedFiles
                });
            } catch (error) {
                reject(error); // Rechaza la promesa con el error
            }
        });
        
    }

    return {
        folderId,
        filesUploaded,
        uploading,
        error,
        success,
        uploadFiles
    };
};

export default useUploadFiles;